module.exports = __webpack_public_path__ + "static/media/ca_HorizontalMED.7d622666.png";